import React from 'react';
import { Controller } from 'react-hook-form';
import { formatDate as defaultFormatDate } from 'buzz_lib_shared';
import { DatePicker } from '../../DatePicker';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DatePickerFormControl = _ref => {
  let {
    label,
    dataId,
    control,
    rules,
    name,
    required,
    formatDate = defaultFormatDate,
    disabled,
    minDate,
    maxDate,
    calendarProps,
    styles
  } = _ref;
  return /*#__PURE__*/_jsx(Controller, {
    name: name,
    control: control,
    rules: rules,
    render: _ref2 => {
      let {
        field: {
          value,
          onChange
        },
        fieldState: {
          error
        }
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(DatePicker, {
          label: label,
          value: value,
          minDate: minDate,
          maxDate: maxDate,
          onSelectDate: onChange,
          formatDate: formatDate,
          "data-id": dataId,
          disabled: disabled,
          isRequired: required,
          calendarProps: calendarProps,
          styles: styles
        }), /*#__PURE__*/_jsx(FieldErrorMessage, {
          children: error === null || error === void 0 ? void 0 : error.message
        })]
      });
    }
  });
};